// extracted by mini-css-extract-plugin
export var loopCarousel = "loop-carousel-module--loop-carousel--57c9d";
export var loopCarousel__body = "loop-carousel-module--loop-carousel__body--35549";
export var loopCarousel__dashedCircle = "loop-carousel-module--loop-carousel__dashed-circle--a83a1";
export var loopCarousel__dashedCircle__1 = "loop-carousel-module--loop-carousel__dashed-circle__1--9b5a2";
export var loopCarousel__dashedCircle__2 = "loop-carousel-module--loop-carousel__dashed-circle__2--bfde6";
export var loopCarousel__dashedCircle__3 = "loop-carousel-module--loop-carousel__dashed-circle__3--f2a1b";
export var loopCarousel__dashedCircle__4 = "loop-carousel-module--loop-carousel__dashed-circle__4--97480";
export var loopCarousel__dotPatternIcon = "loop-carousel-module--loop-carousel__dot-pattern-icon--94e25";
export var loopCarousel__header = "loop-carousel-module--loop-carousel__header--7fc40";
export var loopCarousel__header__title = "loop-carousel-module--loop-carousel__header__title--5a6f5";
export var loopCarousel__homeButton = "loop-carousel-module--loop-carousel__home-button--5bffb";
export var loopCarousel__imgColumn = "loop-carousel-module--loop-carousel__img-column--ffd03";
export var loopCarousel__imgColumn__img = "loop-carousel-module--loop-carousel__img-column__img--3d8a1";
export var loopCarousel__loopIcon = "loop-carousel-module--loop-carousel__loop-icon--1e7fe";
export var loopCarousel__mobileBody = "loop-carousel-module--loop-carousel__mobile-body--893aa";
export var loopCarousel__mobileBody__icon = "loop-carousel-module--loop-carousel__mobile-body__icon--c41ef";
export var mt0 = "loop-carousel-module--mt-0--0da26";
export var mt1 = "loop-carousel-module--mt-1--3667c";
export var mt2 = "loop-carousel-module--mt-2--26a71";
export var mt3 = "loop-carousel-module--mt-3--0b640";
export var mt4 = "loop-carousel-module--mt-4--6c5dc";
export var mt5 = "loop-carousel-module--mt-5--f3a19";
export var mt6 = "loop-carousel-module--mt-6--5edb0";
export var spinKeyframes = "loop-carousel-module--spinKeyframes--1c857";